// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"LoginNavButtons_mainContainer__yV8bT","content":"LoginNavButtons_content__rRerH","divider":"LoginNavButtons_divider__34TOR","link":"LoginNavButtons_link__fxsYW"};